const ResumeTicketActions = ({ onPurchaseClick }) => {
    return (
        <div className="resume-ticket-summary__actions">
            <div className="resume-ticket-summary__action resume-ticket-summary__action--blue">
                <div>
                    <strong>이력서 일반 열람권</strong>
                    <p>지원자 이력서를 횟수 차감 방식으로 열람합니다.</p>
                </div>
                <button type="button" onClick={() => onPurchaseClick?.('ticket-10')}>
                    구매하기
                </button>
            </div>
            <div className="resume-ticket-summary__action resume-ticket-summary__action--red">
                <div>
                    <strong>이력서 자유 열람권</strong>
                    <p>기간 동안 지원자 이력서를 자유롭게 열람합니다.</p>
                </div>
                <button type="button" onClick={() => onPurchaseClick?.('ticket-14')}>
                    구매하기
                </button>
            </div>
        </div>
    );
};

export default ResumeTicketActions;
